import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/base/Button';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-green-100 flex items-center justify-center px-4">
      <div className="max-w-4xl mx-auto text-center">
        {/* 主要内容区域 */}
        <div className="relative">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <img 
              src="/src/assets/images/404-background.jpg"
              alt="绿色环保背景"
              className="w-full h-full object-cover"
            />
          </div>

          {/* 404 大标题 */}
          <div className="relative z-10 mb-8">
            <h1 className="text-8xl md:text-9xl font-bold text-emerald-600 mb-4">
              404
            </h1>
            <div className="flex items-center justify-center space-x-2 text-emerald-700">
              <i className="ri-leaf-line text-3xl"></i>
              <span className="text-xl font-medium">页面走失在绿色森林中</span>
              <i className="ri-leaf-line text-3xl"></i>
            </div>
          </div>

          {/* 环保主题内容 */}
          <div className="relative z-10 mb-12">
            {/* Earth Illustration */}
            <div className="mb-8">
              <img 
                src="/src/assets/images/404-earth.jpg"
                alt="绿色地球"
                className="w-64 h-48 mx-auto rounded-2xl shadow-lg object-cover"
              />
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              抱歉，页面正在进行<span className="text-emerald-600">碳中和</span>处理
            </h2>
            
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
              就像大自然需要时间来净化空气一样，这个页面正在我们的绿色服务器中进行低碳优化。
              让我们一起回到首页，继续探索可持续发展的未来吧！
            </p>

            {/* 环保数据展示 */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 max-w-3xl mx-auto">
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-recycle-line text-emerald-600 text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-800 mb-2">零碳足迹</h3>
                <p className="text-sm text-gray-600">使用绿色能源驱动的服务器</p>
              </div>
              
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-plant-line text-green-600 text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-800 mb-2">数字森林</h3>
                <p className="text-sm text-gray-600">每次访问相当于种植一棵树</p>
              </div>
              
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 shadow-lg">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-water-percent-line text-blue-600 text-2xl"></i>
                </div>
                <h3 className="font-semibold text-gray-800 mb-2">清洁技术</h3>
                <p className="text-sm text-gray-600">100%可再生能源支持</p>
              </div>
            </div>

            {/* 行动按钮 */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link to="/">
                <Button variant="primary" size="lg" className="min-w-48">
                  <i className="ri-home-4-line mr-2"></i>
                  返回绿色首页
                </Button>
              </Link>
              
              <Link to="/#contact">
                <Button variant="outline" size="lg" className="min-w-48 border-emerald-600 text-emerald-600 hover:bg-emerald-600 hover:text-white">
                  <i className="ri-customer-service-2-line mr-2"></i>
                  联系环保专家
                </Button>
              </Link>
            </div>

            {/* 环保提示 */}
            <div className="mt-12 p-6 bg-emerald-50 rounded-xl border border-emerald-200 max-w-2xl mx-auto">
              <div className="flex items-center justify-center mb-3">
                <i className="ri-lightbulb-line text-emerald-600 text-2xl mr-2"></i>
                <span className="font-semibold text-emerald-800">绿色小贴士</span>
              </div>
              <p className="text-emerald-700 text-sm">
                您知道吗？通过优化网页访问路径，每年可以减少约12%的数字碳排放。
                让我们一起为地球的未来贡献一份力量！
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
